module.exports = __webpack_public_path__ + "img/love-woman.35aae758.png";